// extracted by mini-css-extract-plugin
export default {"divider":"K2Tzzq"};